import React from 'react';

import { IconProps } from '@shared/interfaces/icon.interface';

export const NotVerifiedYetIcon: React.FC<IconProps> = ({ width = 24, height = 24, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4.23 21h15.54c1.71 0 2.782-1.845 1.933-3.327L13.939 4.12c-.855-1.491-3.01-1.492-3.865 0L2.297 17.671C1.448 19.154 2.52 21 4.23 21z"
        clipRule="evenodd"
      ></path>
      <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 13V9"></path>
      <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M11.99 17h.02"></path>
    </svg>
  );
};
